import { popOverContainer, popOverStyle } from 'components/Table/SortIndicators/SortIndicator.styles';
import { Popover, PopoverDisclosure, usePopoverState } from 'reakit';
import { css } from '@linaria/core';
import { breakpoints } from 'styles/utils';
import SvgSliders04Md from './Icons/Sliders04Md';
import { PlaygroundChatConfigSidebar } from './PlaygroundChatConfigSidebar';
const ConfigForm = () => {
  return <div className={styles.popoverContent}>
      <PlaygroundChatConfigSidebar />
    </div>;
};
export const ChatConfigInCompareMode = () => {
  const popover = usePopoverState({
    modal: true
  });
  return <>
      <Popover {...popover} className={popOverStyle}>
        <div data-testid="popover" className={popOverContainer}>
          <ConfigForm />
        </div>
      </Popover>
      <PopoverDisclosure {...popover}>
        <button className="popover-button" type="button" aria-label="Chat Config">
          <div className={styles.actionContainer}>
            <SvgSliders04Md />
          </div>
        </button>
      </PopoverDisclosure>
    </>;
};
export const styles = {
  actionContainer: "odules__Playground__Components__ChatConfigInCompareMode_tsx-actionContainer-arp8umf",
  popoverContent: "odules__Playground__Components__ChatConfigInCompareMode_tsx-popoverContent-pbusgee"
};

require("./ChatConfigInCompareMode.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./ChatConfigInCompareMode.tsx");